import TriangleEmptyIcon from "../images/TriangleEmptyIcon.mjs";

/**
 * App icon representing warning signal
 * @see {GlyphIcon}
 * @see {TriangleEmptyIcon}
 */
const AppWarningIcon = class extends TriangleEmptyIcon {};

export default AppWarningIcon;